import { setValidNavigationLinks } from "../_helpers/access-control";
import BrowserHelper from "../_helpers/browser/browser-helper";
import { CompanyStorage } from "../_services/storage";
import appConfig from "../app-config";

let browserHelper = new BrowserHelper();

export const profile = {
  namespaced: true,
  state: {
    applicationMode: localStorage.getItem(
      `applicationMode_${appConfig.VUE_APP_COOKIE_NAME}`
    )
      ? localStorage.getItem(`applicationMode_${appConfig.VUE_APP_COOKIE_NAME}`)
      : '"Gcorp"',
    companyName: "",
  },
  getters: {
    applicationMode: (state) => state.applicationMode,
    companyName: (state) => state.companyName,
  },
  actions: {
    setInitialApplicationMode({ commit }) {
      commit(
        "SET_APPLICATION_MODE",
        localStorage.getItem(`applicationMode_${appConfig.VUE_APP_COOKIE_NAME}`)
          ? localStorage.getItem(
              `applicationMode_${appConfig.VUE_APP_COOKIE_NAME}`
            )
          : browserHelper.tablet
          ? "Gcorp"
          : browserHelper.mobile
          ? "GcorpRoam"
          : "Gcorp"
      );
      setValidNavigationLinks();
    },
    setApplicationMode({ commit }, applicationMode) {
      commit("SET_APPLICATION_MODE", applicationMode);
      setValidNavigationLinks();
    },
    setCompanyName({ commit }) {
      var value = CompanyStorage.getItems(
        `companyName_${appConfig.VUE_APP_COOKIE_NAME}`
      );
      commit("SET_COMPANY_NAME", value);
    },
  },
  mutations: {
    SET_APPLICATION_MODE(state, applicationMode) {
      state.applicationMode = applicationMode;
      localStorage.setItem(
        `applicationMode_${appConfig.VUE_APP_COOKIE_NAME}`,
        applicationMode
      );
    },
    SET_COMPANY_NAME(state, companyName) {
      if (companyName != null) {
        state.companyName = companyName;
        localStorage.setItem(
          `companyName_${appConfig.VUE_APP_COOKIE_NAME}`,
          companyName
        );
      }
    },
  },
};
